import gql from 'graphql-tag';

export default gql`
mutation DeleteEndpoint(
        $uuid: String!,
      ) {
    deleteEndpoint(input:{
        uuid: $uuid,
    }) {
      __typename
    }
}
`;
